import {
    Center, HStack, Spinner, Text, VStack,
} from '@chakra-ui/react';
import { DiLogo, LogoVariant } from '../di-logo';

export interface AppLoaderProps {
    variant?: LogoVariant;
    loadingText?: string;
}

export function AppLoader({ variant = 'horizontalRGB', loadingText = '' }: AppLoaderProps) {
    return (
        <Center w="100%" h="100vh">
            <VStack spacing={8}>
                <DiLogo variant={variant} w="xs" />
                <HStack spacing={4}>
                    <Spinner data-testid="app-loader" color="primary.500" />
                    <Text>{loadingText}</Text>
                </HStack>
            </VStack>
        </Center>
    );
}
